import React from 'react'
import PropTypes from 'prop-types'
import { useField, ErrorMessage } from 'formik'

// Styled Elements
import { FormInputWrapper, FormLabel, FormTextFieldInput, FormErrorMessage } from './FormTextField.elements'

function FormTextField(props) {
  // Destructure
  const { type, label, disabled, ...rest } = props

  // Hooks
  const [fields] = useField(props)

  return (
    <FormInputWrapper label={label}>
      {label && <FormLabel disabled={disabled}>{label}</FormLabel>}
      <FormTextFieldInput disabled={disabled} type={type} {...fields} {...rest} />
      <FormErrorMessage>
        <ErrorMessage {...fields} />
      </FormErrorMessage>
    </FormInputWrapper>
  )
}

// Default Props
FormTextField.defaultProps = {
  type: '',
  label: '',
  disabled: false,
}

// Proptypes Validation
FormTextField.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
}

export default FormTextField
